import React from "react";
import { Paper, Box, Typography, Tooltip, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { COLORS } from "../../constants";
import { ConfigSectionProps } from "../../types";

export const ConfigSection: React.FC<ConfigSectionProps> = ({
  title,
  children,
  tooltip,
}) => (
  <Paper
    elevation={1}
    sx={{
      p: 2,
      mb: 2,
      border: `1px solid ${COLORS.PRIMARY}`,
      boxShadow: `0 4px 8px ${COLORS.PRIMARY_SHADOW}`,
    }}
  >
    <Box display="flex" alignItems="center" mb={2}>
      <Typography
        variant="h6"
        component="h3"
        sx={{ flexGrow: 1, color: COLORS.PRIMARY }}
      >
        {title}
      </Typography>
      {tooltip && (
        <Tooltip title={tooltip}>
          <IconButton size="small" sx={{ color: "#9ca3afab" }}>
            <InfoIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
    {children}
  </Paper>
);
